angular.module('impactx.datepicker').directive('ixTimePicker', function($timeout) {
    return {
        scope: {
            date: "=",
            dialogData: "=",
            readOnly: "=",
            disableMinutes: "="
        },
        restrict: 'E',
        templateUrl: 'shared/datepicker/templates/timepicker.tmpl.html',
        transclude: true,
        link: function(scope) {
            scope.isDate = angular.isDate;
            scope.clickTimePicker = function() {
                //I know this is stupid, but the timepicker seems to change the reference to the value, so the watchers won't work :/
                if (scope.dialogData) {
                    scope.dialogData.$setDirty();
                }
                if (scope.disableMinutes) {
                    var elementWatcher = scope.$watch(
                        function () {
                            return document.querySelectorAll('.mdp-timepicker-selected-time span:nth-child(2)').length
                        },
                        function (newValue) {
                            if (newValue > 0) {
                                elementWatcher();
                                angular.element(document.querySelector('.mdp-timepicker-selected-time span:nth-child(2)')).css('pointer-events', 'none');
                            }
                        }
                    );
                }
            };
            scope.$watch("date.dateValue", function(newValue) {
                if(newValue) {
                    if(!angular.isDate(newValue)) {
                        scope.date.dateValue = new Date(newValue);

                        // this is better than  scope.$broadcast('md-calendar-change', scope.date.dateValue) because the form stays clean
                        if(scope.dialogData) {
                            scope.dialogData.$setPristine();
                            scope.dialogData.$setUntouched();
                        }
                    }
                }
                else {
                    if(!scope.date) {
                        scope.date = {};
                    }
                    scope.date.dateValue = null;
                }
            });
        }
    };
});